import { flatten } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { formatCustomFieldsPayload } from 'Helpers/customFields/customFieldsHelpers';

const getContacts = (queryLimit) => {
    return ApiClient.get('/contacts', { limit: queryLimit });
};

const searchContacts = (query, typeArray, queryLimit, controllerSignal) => {
    return ApiClient.get(
        '/search',
        {
            q: query,
            type: typeArray,
            limit: queryLimit,
        },
        controllerSignal,
    );
};
const getAllContactsForCompanyOrIndividual = async ({ isIndividual, id }) => {
    let data = [];
    let pagination = { offset: '', total: 0 };
    const filters = !isIndividual ? { companies: [id] } : { individuals: [id] };
    do {
        const response = (
            await ApiClient.post(
                '/contacts/search',
                { offset: pagination.offset },
                {
                    filters,
                },
            )
        ).data;
        pagination = response?.pagination ?? pagination;
        data = data.concat(response?.data ?? []);
    } while (data.length < pagination.total);
    return data;
};

const createContactAndLinkToThird = (contactPayload, linkedType, linkedId) => {
    return new Promise((resolve, reject) => {
        const uuid = uuidv4();
        let thirdEndpoint = `/companies/${linkedId}/contacts/${uuid}`;
        if (linkedType === 'individual') {
            thirdEndpoint = `/individuals/${linkedId}/contacts/${uuid}`;
        }

        const request = [
            { uri: '/contacts', method: 'POST', uuid },
            { ...contactPayload },
            { uri: thirdEndpoint, method: 'POST', uuid },
            {},
        ];
        ApiBatchClient.post('/batch', {}, flatten(request).map(JSON.stringify).join('\n'))
            .then(({ data }) => {
                if (data.responses.some((response) => response.code !== 201)) {
                    reject();
                }
                resolve({ data: data.responses[0]?.response });
            })
            .catch((error) => reject(error));
    });
};

const getContactMetadata = () => {
    return ApiClient.get('/contacts/metadata');
};

export const getAllContactsCustomFields = async () => {
    let customFields = [];
    let pagination = {
        limit: 100,
        offset: '',
    };

    do {
        const response = await ApiClient.post('/custom-fields/search', pagination, {
            filters: {
                related_object: 'contact',
            },
        });
        customFields = customFields.concat(response.data.data);
        pagination = response.data.pagination;
    } while (pagination.total > customFields.length);

    return customFields;
};

export const updateContactCustomFields = async (contactId, customFields, verify = false) => {
    try {
        const customFieldsPayload = formatCustomFieldsPayload(customFields);
        return await ApiClient.put(
            `/contacts/${contactId}/custom-fields`,
            { verify },
            customFieldsPayload,
        );
    } catch (e) {
        const error = e.response?.data?.error;
        if (error?.code === 400 && error?.details) {
            const errorThrow = new Error('customfields', { cause: 'customfields' });
            errorThrow.details = error.details;
            throw errorThrow;
        }
    }
};

export const updateContact = async (contactId, contactPayload) => {
    return ApiClient.put(`/contacts/${contactId}`, {}, contactPayload);
};

export {
    getContacts,
    searchContacts,
    getAllContactsForCompanyOrIndividual,
    createContactAndLinkToThird,
    getContactMetadata,
};
